import {menuItems} from '@/constants/menu';
import BonusUI from '@/data/bonusui.json';

const SIDEBAR_STORAGE_KEY = 'sidebarToggleState';
// Below this the layout has no room for the sidebar, so it collapses regardless of preference.
const SIDEBAR_BREAKPOINT = 1007;

function readStoredSidebar() {
  const raw = localStorage.getItem(SIDEBAR_STORAGE_KEY);
  return raw === null ? true : JSON.parse(raw);
}

function storeSidebar(open) {
  localStorage.setItem(SIDEBAR_STORAGE_KEY, JSON.stringify(open));
}

const state = {
  data: menuItems.data,
  megamenu: BonusUI.data,
  searchData: [],
  togglesidebar: readStoredSidebar(),
  activeoverlay : false,
  searchOpen : false,
  customizer: '',
  hideRightArrowRTL: false,
  hideLeftArrowRTL: true,
  hideRightArrow: true,
  hideLeftArrow: true,
  width: 0,
  height: 0,
  margin: 0,
  menuWidth: 0,
  // Null until the first resize check, so that check counts as crossing the breakpoint.
  isNarrowViewport: null,
};


const getters = {

};


const mutations = {
  opensidebar: (state) => {
    state.togglesidebar = !state.togglesidebar;
    storeSidebar(state.togglesidebar);
    if (window.innerWidth < 991) {
      state.activeoverlay = true;
    } else {
      state.activeoverlay = false;
    }
  },
  /**
   * Fires on every resize event, so it must not write to storage: it used to force the sidebar
   * open above the breakpoint and save that, which meant opening devtools or changing zoom
   * silently threw away a collapsed sidebar. Only a deliberate act persists a choice now.
   */
  resizetoggle: (state) => {
    const narrow = window.innerWidth < SIDEBAR_BREAKPOINT;
    // A resize inside one bucket changes nothing about how the sidebar should sit.
    if (narrow === state.isNarrowViewport) return;
    state.isNarrowViewport = narrow;
    // Narrow collapses for layout alone and is never stored, or a phone visit would overwrite the
    // desktop choice. Going wide again restores what the manager actually picked.
    state.togglesidebar = narrow ? false : readStoredSidebar();
  },
  /** Commands a specific state and remembers it — `opensidebar` can only flip. */
  setsidebar: (state, open) => {
    state.togglesidebar = open;
    storeSidebar(open);
  },
  setSearchData: (state, items) => {
    state.searchData = items;
  },
  searchTerm: (state, term) => {
    let items = [];
    var searchval = term.toLowerCase();
    state.data.filter(menuItems => {

      if (menuItems.title) {
        if (menuItems.title.toLowerCase().includes(searchval) && menuItems.type === 'link') {
          items.push(menuItems);
        }
        if (!menuItems.children) return false;
        menuItems.children.filter(subItems => {
          if (subItems.title.toLowerCase().includes(searchval) && subItems.type === 'link') {
            subItems.icon = menuItems.icon;
            items.push(subItems);
          }
          if (!subItems.children) return false;
          subItems.children.filter(suSubItems => {
            if (suSubItems.title.toLowerCase().includes(searchval)) {
              suSubItems.icon = menuItems.icon;
              items.push(suSubItems);
            }
          });
        });
        state.searchData = items;
      }
    });
  },
  setBonusNavActive: (state, item) => {
    if (!item.active) {
      state.megamenu.forEach(a => {
        if (state.megamenu.includes(item))
          a.active = false;
        if (!a.children) return false;
        a.children.forEach(b => {
          if (a.children.includes(item)) {
            b.active = false;
          }
        });
      });
    }
    item.active = !item.active;
  },
  setNavActive: (state, item) => {
    function resetActiveStates(items) {
      items.forEach(menuItem => {
        menuItem.active = false;
        if (menuItem.children) {
          resetActiveStates(menuItem.children);
        }
      });
    }

    function deactivateSiblings(items, targetItem) {
      items.forEach(menuItem => {
        if (menuItem !== targetItem) {
          menuItem.active = false;
          if (menuItem.children) {
            resetActiveStates(menuItem.children);
          }
        }
      });
    }

    function toggleItem(items, targetItem) {
      items.forEach(menuItem => {
        if (menuItem === targetItem) {
          menuItem.active = !menuItem.active;
          if (menuItem.children && menuItem.active) {
            // If the item is now active and has children, reset all its children's active state
            resetActiveStates(menuItem.children);
          }
        } else {
          menuItem.active = false;
        }
        if (menuItem.children) {
          toggleItem(menuItem.children, targetItem);
        }
      });
    }

    function activateItem(items, targetItem) {
      items.forEach(menuItem => {
        if (menuItem === targetItem) {
          deactivateSiblings(items, targetItem);
          menuItem.active = !menuItem.active;
          if (menuItem.children && menuItem.active) {
            resetActiveStates(menuItem.children);
          }
        }
        if (menuItem.children) {
          activateItem(menuItem.children, targetItem);
        }
      });
    }

    activateItem(state.data, item);
  },

  setActiveRoute: (state, item) => {
    // First, reset all menu items to inactive
    function resetAllMenuItems(items) {
      items.forEach(menuItem => {
        menuItem.active = false;
        if (menuItem.children) {
          resetAllMenuItems(menuItem.children);
        }
      });
    }

    // Then, activate the target item and its parents
    function activateItemAndParents(items, targetItem) {
      for (const menuItem of items) {
        if (menuItem === targetItem) {
          menuItem.active = true;
          return true;
        }
        if (menuItem.children) {
          const found = activateItemAndParents(menuItem.children, targetItem);
          if (found) {
            menuItem.active = true;
            return true;
          }
        }
      }
      return false;
    }

    // Reset all items first, then activate the target and its parents
    resetAllMenuItems(state.data);
    activateItemAndParents(state.data, item);
  },

  SET_SEARCH_OPEN(state, isOpen) {
    state.searchOpen = isOpen;
  },

};

const actions = {
  opensidebar: (context, term) => {
    context.commit('opensidebar', term);
  },
  resizetoggle: (context, term) => {
    context.commit('resizetoggle', term);
  },
  setsidebar: (context, open) => {
    context.commit('setsidebar', open);
  },
  setBonusNavActive: (context, term) => {
    context.commit('setBonusNavActive', term);
  },
  searchTerm: (context, term) => {
    context.commit('searchTerm', term);
  },
  setNavActive: (context, item) => {
    context.commit('setNavActive', item);
  },
  setActiveRoute: (context, item) => {
    context.commit('setActiveRoute', item);
  },
  setSearchData: (context, items) => {
    context.commit('setSearchData', items);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};